import React from 'react';
import flow from 'lodash.flow';
import Column from './Column';
import ColumnResizer from './ColumnResizer';
import Highlightable from '../HOCs/Highlightable';
import { connect } from 'react-redux';

import styles from '../../../../stylesheet/css/header-builder/row.css';

function renderColumnResizers(device, id, columns, spacing) {
  return false;
  return columns.slice(0, columns.length - 1).map(column => {
    return <ColumnResizer key={column.id}
      device={device} rowId={id} columnId={column.id} width={spacing} />;
  });
}

let Row = React.createClass({
    render() {
      const {
        device,
        id,
        columns,
        isHighlighted,
        onHighlight,
        options = {},
      } = this.props;

      const spacing = 8;

      if (columns.length > 6) {
        for (let col of columns) {col.width = 0;}
        if (columns.length == 11) {
          columns[0].width = 8;
          columns[1].width = 4;
        }
        if (columns.length == 7) {
          columns[0].width = 2;
          columns[1].width = 10;
        }
        if (columns.length == 8) {
          columns[0].width = 2;
          columns[1].width = 8;
          columns[2].width = 2;
        }
        if (columns.length == 12) {
          columns[0].width = 1;
          columns[1].width = 10;
          columns[2].width = 1;
        }
        if (columns.length == 10) {
          columns[0].width = 1;
          columns[1].width = 1;
          columns[2].width = 1;
          columns[3].width = 9;
        }
      }

      let className = styles.gridRow;

      if (isHighlighted) {
        className += ' ' + styles.highlighted;
      }

      return (
        <div className={className} onClick={onHighlight}>
          <table style={{ borderSpacing: `${spacing}px` }}>
            <tbody>
              <tr>
                {columns.map(column => <Column key={column.id} device={device} rowId={id} {...column} />)}
              </tr>
            </tbody>
          </table>
          {renderColumnResizers(device, id, columns, spacing)}
        </div>
      );
    }
});

Row = flow(
  Highlightable(),
)(Row);

export { Row };

const mapStateToProps = (state) => ({
  ...state
});

export default connect(
  mapStateToProps,
  null
)(Row);



// WEBPACK FOOTER //
// ./app/header-builder/components/Row.js